export * from "./appManagementFunctions.web";